/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInvoiceDetails } from 'actions/invoiceDetailsAction';
import FSBModal from 'components/common/FSBModal';
import PaymentDetails from './components/PaymentDetails';

const InvoiceDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedInvoice } = useSelector(
    (state) => state.invoiceDetailsReducer,
  );
  const drawerToggle = () => {
    dispatch(setInvoiceDetails({ status: false, selectedInvoice: null }));
  };

  useEffect(() => {
    dispatch(setInvoiceDetails({ status: false, selectedInvoice: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <div>
      {' '}
      {status && (
        <FSBModal
          open={status}
          size="xl"
          title="Invoices Details"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass="right-drawer right-drawer-details"
        >
          <PaymentDetails invoicesDetail={selectedInvoice} />
        </FSBModal>
      )}
    </div>
  );
};

export default InvoiceDetailsDrawer;
